import React from 'react';
import { Layout, Typography } from 'antd';
import { CodeOutlined } from '@ant-design/icons';
import ProjectExplorer from './components/ProjectExplorer';

const { Header, Content } = Layout;
const { Title } = Typography;

const App: React.FC = () => {
  return (
    <Layout style={{ height: '100vh', background: '#1e1e1e' }}>
      <Header style={{ 
        background: '#2d2d30', 
        borderBottom: '1px solid #3e3e42',
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center'
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CodeOutlined style={{ fontSize: '24px', color: '#007acc', marginRight: '12px' }} />
          <Title level={3} style={{ color: '#cccccc', margin: 0 }}>
            Java Project Explorer
          </Title>
        </div>
      </Header>
      
      <Content style={{ background: '#1e1e1e', overflow: 'hidden' }}>
        <ProjectExplorer />
      </Content>
    </Layout>
  );
};

export default App;